import React, { useState } from 'react'
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import HoverImage from "react-hover-image/build";
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import { Button } from 'reactstrap';
import Drawer from 'components/Drawer';
import AddCrossWalkDrawer from '../AddCrosswalk';
import plus from "assets/icon/plus-icon.svg";
import { toast } from 'react-toastify';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import moment from 'moment';
import useAxios from 'hooks/useAxios';
import { cloneDeep } from 'lodash';
import Smallspinlogo from "assets/images/upload.gif";
import { ModuleAccess } from 'utils/moduleaccess';


let rowForEdit = {};

const CrosswalkMapingTable = (props) => {
  const { mapingHistoryData, setMapingHistoryData, orgId, setLoading, loading, Crosswalkrefetc, crosswalksearch, unmappedchargesearch, tabkey, chargeCodeDetails, setIshiddenflag, ishiddenflag,storedDate } = props;
  //  const [tableData, setTableData] = useState(dummydata)
  const [addmapings, setAddMapings] = useState(false);
  const [showWarning, setShowWarning] = useState('');
   const [bupperr, setBuppErr] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const API = useAxios()
  const handelAddMaping = () => {
    setAddMapings(!addmapings);
  };
  const handelClickimage = () => {
    setChargeCodeflag(false)
  };
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit1(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "drugDescription",
      text: "NDC Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    // {
    //   dataField: "ndc",
    //   text: "NDC",
    //   sort: false,
    //   width: 180,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.ndc),
    // },

    {
      dataField: "startDate",
      text: "Effective Date",
      sort: false,
      width: 160,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "endDate",
      text: "Term Date",
      sort: false,
      width: 200,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "bupp",
      text: "BUPP",
      sort: false,
      width: 140,
      show: true,
      inputType: "number",
      edit: true,
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "number"),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },

  ];
  const editRow1 = (rowData, isEdit = true) => {

    setShowWarning('')
    let tempData = [...mapingHistoryData];
    console.log(tempData, "tempData in Edit Row")
    tempData = tempData.map((row) => {
      // debugger;
      row.isEdit = false;
      if (row.chargeDrugID === rowData?.chargeDrugID && isEdit) {
        row.isEdit = isEdit;
        // row.endDate=dateFormate(row.endDate)
        rowForEdit = row;
        console.log(rowForEdit, "rowForEdit in edit Row")
        console.log(row, "row in edit Row")
      }
      return row;

    });
    setMapingHistoryData(tempData);
  };
  const editRow = (rowData, isEdit = true) => {
    debugger;
    setShowWarning('');
    if (isEdit == false) {
      setIshiddenflag(false);
    }
    let tempData = [...mapingHistoryData];
    if (isEdit) {
      let formattedRowData = { ...rowData };
      if (rowData.startDate) {
        const date = dateFormate(rowData.startDate);
        formattedRowData.startDate = date;
      }
      if (rowData.endDate) {
        const date = dateFormate(rowData.endDate);
        formattedRowData.endDate = date;
      }
      setOriginalData(formattedRowData);
    }
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.chargeDrugID === rowData?.chargeDrugID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;

    });
    setMapingHistoryData(tempData);
  };

  const renderspin = (rowData) => {

    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        // onClick={()=>togglemapingview(rowData)}
        title="Reprocessing In progress"
        hidden={rowData.reProcessedFlag == "N"}
      >
        <HoverImage
          key="Maping"
          src={Smallspinlogo}
          hoverSrc={Smallspinlogo}
          alt=""
        />
      </Button>
    );
  };
  const fetchmapingHistory = async (rowData) => {
    debugger;
    let chargeId = rowData?.chargeID;
    let payload = {}
    if (tabkey == "chargeCodes") {
      payload = cloneDeep(unmappedchargesearch);

    }
    if (tabkey == "crosswalk") {
      payload = cloneDeep(crosswalksearch);
    }

    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/ChargeCodeMappingHistory/${chargeId}`, payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setMapingHistoryData(data.items);
        setLoading(false);
      }
      else {
        setMapingHistoryData([]);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  }
  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  };
  const cellRenderEdit1 = (rowData) => {
    if (hasPermission('ED'))
      return (
        <div className="d-flex align-items-center">
          {cellRenderEdit(rowData)}
          {renderspin(rowData)}

        </div>
      );
  };
  const saveUpdateRow = async () => {
    debugger;
    setIshiddenflag(false);
    let payload = { ...rowForEdit };
    payload.startDate = payload.startDate != null ? dateFormate(payload.startDate) : null;
    payload.endDate = payload.endDate != null ? dateFormate(payload.endDate) : null;

   if (payload.endDate && new Date(payload.endDate) < new Date(payload.startDate)) {
      return setShowWarning('Term Date must be Greater Than or Equal to EffectiveDate');
    }
     if (payload.bupp == "" || payload.bupp == null || payload.bupp == "0") {
      return setBuppErr(true)
    }
    setLoading(true)
    if (payload.endDate !== null) {
      payload.endDate = moment(payload.endDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    }
    payload.startDate = moment(payload.startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    delete payload.isEdit;
    try {
      const result = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/UpdateMappingHistory`,
        payload,
        {
          hasDefaultURL: true,
        }
      );

      if (result.data == true) {
        toast.success('Updated Successfully');
        fetchmapingHistory(payload)
        // Crosswalkrefetc(true);
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };

  const cellRenderEdit = (row) => {
    return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} ishiddenflag={ishiddenflag} setIshiddenflag={setIshiddenflag} />;
  };

  const isEqual = (a, b) => {
    const normalize = val => (val === null || val === undefined || val === "") ? "" : val;
    return normalize(a).toString() === normalize(b).toString();
  };

  const updateRowValue = (value, col) => {
    debugger;
    if (col === 'endDate' && value !== "") {
      setShowWarning('');
    }
    const tempRow = { ...rowForEdit };

    if (rowForEdit.startDate) {
      tempRow.startDate = dateFormate(rowForEdit.startDate);
    }
    if (rowForEdit.endDate) {
      tempRow.endDate = dateFormate(rowForEdit.endDate);
    }

    tempRow[col] = value;

    const isSame =
      isEqual(originalData.bupp, tempRow.bupp) &&
      isEqual(originalData.startDate, tempRow.startDate) &&
      isEqual(originalData.endDate, tempRow.endDate);

    setIshiddenflag(!isSame);
    rowForEdit = tempRow;
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          //hasTouched={hasTouched}
          showWarning={showWarning}
          crosswalktab='chargeCode'
          endDateFormatter={true}
          alwaysEditableCheckbox={alwaysEditableCheckbox}

        />
      );

    }

    else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          wacErr={bupperr}
        // alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
  };
  return (
    <div>
      <div className='d-flex'>
        <h3 className='f-16 font-weight-600' style={{ color: "#702C62" }}>Crosswalk Mappings

        </h3>
        <Button size='sm'
          color='primary'
          className='ms-auto upload_btn'
          // style={{marginRight:"10px",padding:"2px 8px"}}
          hidden={!(hasPermission('AD'))}
          // hidden={(!(hasPermission2('UP')) && add == "Upload") || (!hasPermission('AD') && add == "Add")} 

          onClick={handelAddMaping}

        > <span className="" style={{ paddingRight: "4px", position: "relative", top: "-1px", }}><img src={plus} alt="" /></span>
          Add
        </Button>
      </div>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={mapingHistoryData?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="chargecode-mapingtable"
          height={550}
          fixedColumn
          width={1200}

          //   hasPagination
          // reset={reset}
          data={mapingHistoryData}
          columns={mainCol}
          // buttononclick={handelAddMaping}

          //   filters={[]}
          //   totalRecords={10}
          display={true}
          hidefilter={true}
          pageSize={1}
          //  add={"Add"}
          //   currentPage={1}


          showtoggle={false}

        />

      </div>
      <Drawer
        direction="end"
        isOpen={addmapings}
        toggle={handelAddMaping}
        size="md"
        title="New Mapping"
      >
        <AddCrossWalkDrawer loading={loading} handelAddMaping={handelAddMaping} setLoading={setLoading} orgId={orgId} unmappedchargesearch={tabkey == "chargeCodes" ? unmappedchargesearch : crosswalksearch} chargeCodeDetails={chargeCodeDetails} setMapingHistoryData={setMapingHistoryData}  storedDate={storedDate}/>
      </Drawer>
    </div>
  )
}

export default CrosswalkMapingTable